"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};

var RightArrow = function RightArrow(props) {
  var finalProps = {
    ...defaultProps,
    ...props,
  };
  return _react["default"].createElement("svg", finalProps, _react["default"].createElement("path", {
    d: "M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z"
  }));
};

var _default = RightArrow;
exports["default"] = _default;
